import { RedirectRegexToTargetApp, oldParcelRegex } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function ParcelRedirectRoute() {
  return <RedirectRegexToTargetApp regex={oldParcelRegex} targetApp="design-studio" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/parcel/')({
  component: ParcelRedirectRoute,
});
